import { deleteData, getData, patchData, postData } from "../api/api";
import type { PageResponse, QuerySchemaResponse } from "../types/dashboard";
import type {
  DashboardQuery,
  DashboardQueryDslProbeResponse,
  DashboardQueryProbeRequest,
  DashboardQueryValidationResponse,
} from "../types/query";

const BASE = "/dashboard-queries";

export const dashboardQueryService = {
  list: (page = 0, size = 20) =>
    getData(`${BASE}?page=${page}&size=${size}`) as Promise<PageResponse<DashboardQuery>>,

  get: (id: string) => getData(`${BASE}/${id}`) as Promise<DashboardQuery>,

  create: (query: DashboardQuery) => postData(BASE, query) as Promise<DashboardQuery>,

  update: (id: string, query: DashboardQuery) =>
    patchData(`${BASE}/${id}`, query) as Promise<DashboardQuery>,

  remove: (id: string) => deleteData(`${BASE}/${id}`),

  validate: (query: DashboardQuery) =>
    postData(`${BASE}/validate`, query) as Promise<DashboardQueryValidationResponse>,

  probeDsl: (body: DashboardQueryProbeRequest) =>
    postData(`${BASE}/dsl-probe`, body) as Promise<DashboardQueryDslProbeResponse>,

  schema: (id: string, body?: { objectName?: string }) =>
    postData(`${BASE}/${id}/schema`, body ?? {}) as Promise<QuerySchemaResponse>,
};
